export const environment = {
  production: false,
  apiUrl: 'https://api-access-guard-dev-migration.www.floodwaive.de/v1', // Placeholder
};


